import { Activity, memo } from 'react';
import classNames from 'classnames';

import styles from '../custom-select.module.css';

import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import { CustomSelectRemoveIconProps, CustomSelectFocusedItemsProps } from '../custom-select.types';

const RemoveIcon = ({
  lockActiveState,
  handlePreventDefaultClick,
  option,
  handleRemoveClick,
  idx,
}: CustomSelectRemoveIconProps) => {
  return (
    <span
      inert={!lockActiveState}
      role="button"
      aria-label={`Remove option ${option.label}`}
      className={styles.removeOptionBtn}
      onPointerDown={handlePreventDefaultClick}
      onClick={handleRemoveClick(option.value)}
      data-remove-option
      data-remove-option-active="false"
      data-remove-option-idx={idx}
      data-remove-option-value={option.value}
    >
      <Icon size={9} name={ICONS.CLOSE} color="var(--local-chip-input-default-icotext)" />
    </span>
  );
};

const CustomSelectFocusedItems = memo(
  ({
    handlePreventDefaultClick,
    handleToggleMenu,
    selectedOptions,
    selectedOptionsRef,
    RenderFocusedLabelContent,
    lockActiveState,
    handleRemoveClick,
    direction = 'horizontal',
    chipNodesRef,
  }: CustomSelectFocusedItemsProps) => {
    const isVertical = direction === 'vertical';
    return (
      <Activity mode={selectedOptions.length && lockActiveState ? 'visible' : 'hidden'}>
        <div
          className={classNames('flex ai-center gap-8', styles.selectedOptions, {
            [styles['selected-options-vertical']]: isVertical,
          })}
          onPointerDown={handlePreventDefaultClick}
          onClick={handleToggleMenu}
          ref={selectedOptionsRef}
        >
          {selectedOptions.map((so, idx) => {
            return (
              <div
                key={so.value}
                ref={(el) => {
                  if (chipNodesRef?.current) {
                    chipNodesRef.current[idx] = el;
                  }
                }}
                data-custom-select-selected-option={so.value}
                className={`flex ai-center jc-flex-start gap-8 ${styles.selectedOption}`}
              >
                {RenderFocusedLabelContent ? (
                  <RenderFocusedLabelContent
                    option={so}
                    idx={idx}
                    RemoveIcon={
                      <RemoveIcon
                        lockActiveState={lockActiveState}
                        handlePreventDefaultClick={handlePreventDefaultClick}
                        option={so}
                        handleRemoveClick={handleRemoveClick}
                        idx={idx}
                      />
                    }
                  />
                ) : (
                  <>
                    <span>{so.label}</span>
                    <RemoveIcon
                      lockActiveState={lockActiveState}
                      handlePreventDefaultClick={handlePreventDefaultClick}
                      option={so}
                      handleRemoveClick={handleRemoveClick}
                      idx={idx}
                    />
                  </>
                )}
              </div>
            );
          })}
        </div>
      </Activity>
    );
  }
);

CustomSelectFocusedItems.displayName = 'CustomSelectFocusedItems';

export default CustomSelectFocusedItems;
